import { queryOptions } from '@tanstack/react-query';
import { mediaHttp } from '@/lib/api/http-client';
import { parseResponse } from '@/lib/api/parse-response';
import { MEDIA_CONNECTOR_QUERY_KEYS } from './query-keys';
import { connectorListSchema, platformListSchema, syncStatusListSchema } from './schemas';

export const mediaConnectorsQueryOptions = () =>
  queryOptions({
    queryKey: MEDIA_CONNECTOR_QUERY_KEYS.list(),
    queryFn: async ({ signal }) => {
      const res = await mediaHttp.get({
        responseType: 'json',
        security: [{ scheme: 'bearer', type: 'http' }],
        url: '/api/v1/media-connectors',
        signal,
      });

      return parseResponse(connectorListSchema, res);
    },
  });

/**
 * Platforms the workspace may use. The backend filters this by each platform's
 * `media_connector_<platform>` feature flag, so the connectors page renders only
 * the platforms present in `items` — this is the single source of truth for which
 * connectors are enabled.
 */
export const listPlatformsQueryOptions = () =>
  queryOptions({
    queryKey: MEDIA_CONNECTOR_QUERY_KEYS.platforms(),
    queryFn: async ({ signal }) => {
      const res = await mediaHttp.get({
        responseType: 'json',
        security: [{ scheme: 'bearer', type: 'http' }],
        url: '/api/v1/media-connectors/platforms',
        signal,
      });

      return parseResponse(platformListSchema, res);
    },
  });

export const syncStatusQueryOptions = () =>
  queryOptions({
    queryKey: MEDIA_CONNECTOR_QUERY_KEYS.syncStatus(),
    queryFn: async ({ signal }) => {
      const res = await mediaHttp.get({
        responseType: 'json',
        security: [{ scheme: 'bearer', type: 'http' }],
        url: '/api/v1/media-sync/status',
        signal,
      });

      return parseResponse(syncStatusListSchema, res);
    },
    refetchInterval: 30_000,
  });
